import arAE from './ar_AE.json';
import arSA from './ar_SA.json';
import arQA from './ar_QA.json';
import csCZ from './cs_CZ.json';
import daDK from './da_DK.json';
import deAT from './de_AT.json';
import deDE from './de_DE.json';
import elGR from './el_GR.json';
import enAU from './en_AU.json';
import enCA from './en_CA.json';
import enGB from './en_GB.json';
import enIE from './en_IE.json';
import enJO from './en_JO.json';
import enNZ from './en_NZ.json';
import enPR from './en_PR.json';
import enSG from './en_SG.json';
import enUS from './en_US.json';
import enZA from './en_ZA.json';
import esES from './es_ES.json';
import esPR from './es_PR.json';
import fiFI from './fi_FI.json';
import frCA from './fr_CA.json';
import frCH from './fr_CH.json';
import frFR from './fr_FR.json';
import frLU from './fr_LU.json';
import heIL from './he_IL.json';
import hrHR from './hr_HR.json';
import huHU from './hu_HU.json';
import isIS from './is_IS.json';
import itIT from './it_IT.json';
import jaJP from './ja_JP.json';
import koKR from './ko_KR.json';
import nlBE from './nl_BE.json';
import nlNL from './nl_NL.json';
import noNO from './no_NO.json';
import plPL from './pl_PL.json';
import ptPT from './pt_PT.json';
import roRO from './ro_RO.json';
import slSI from './sl_SI.json';
import svSE from './sv_SE.json';
import thTH from './th_TH.json';
import trTR from './tr_TR.json';
import zhHK from './zh_HK.json';
import zhMO from './zh_MO.json';
import zhTW from './zh_TW.json';
import defaultSolution from './defaultSolution.json';

/**
 * Gets the solutions for a model for a locale
 * @param {string} locale - en_US, fr_CA
 * @param {boolean} isIraDocumentGenerationEnabled - determines if IRA Generation is enabled
 * @return {object} localized solutions object
 */
const mappings = (locale, isIraDocumentGenerationEnabled) => {
  const solutions = {
    ar_AE: arAE,
    ar_SA: arSA,
    ar_QA: arQA,
    cs_CZ: csCZ,
    da_DK: daDK,
    de_AT: deAT,
    de_DE: deDE,
    el_GR: elGR,
    en_AU: enAU,
    en_CA: enCA,
    en_GB: enGB,
    en_IE: enIE,
    en_JO: enJO,
    en_NZ: enNZ,
    en_PR: enPR,
    en_SG: enSG,
    en_TH: thTH,
    en_US: enUS,
    en_ZA: enZA,
    es_ES: esES,
    fi_FI: fiFI,
    fr_CA: frCA,
    fr_CH: frCH,
    fr_FR: frFR,
    fr_LU: frLU,
    he_IL: heIL,
    hr_HR: hrHR,
    hu_HU: huHU,
    is_IS: isIS,
    it_IT: itIT,
    ja_JP: jaJP,
    ko_KR: koKR,
    nl_BE: nlBE,
    nl_NL: nlNL,
    no_NO: noNO,
    pl_PL: plPL,
    pt_PT: ptPT,
    ro_RO: roRO,
    sl_SI: slSI,
    sv_SE: svSE,
    tr_TR: trTR,
    zh_HK: zhHK,
    zh_MO: zhMO,
    zh_TW: zhTW,
    // Countries with additional languages
    en_AE: arAE,
    en_SA: arSA,
    en_QA: arQA,
    de_CH: frCH,
    de_LU: frLU,
    it_CH: frCH,
    fr_BE: nlBE,
    es_PR: esPR,
    en_HK: zhHK,
    en_MO: zhMO,
    th_TH: thTH,
  };

  if (solutions[locale]) {
    if (locale === 'en_US' && isIraDocumentGenerationEnabled) {
      solutions.en_US.data.push({
        key: 'generateIraDocument',
        children: [],
      });
      return solutions.en_US;
    }
    return solutions[locale];
  }

  return defaultSolution;
};

export default mappings;
